import React, { useState, useEffect } from 'react'
import OnVisible from 'react-on-visible'
import { Section, LinkWithArrow, Image, BlogButton, Link } from 'newComponents'
import chevron from '../../images/ebook/thin-chevron.svg'
import './styles.scss'

const CardGrid = (props) => {
  const { data } = props
  const { items } = data

  const tabList = ['All Events']
  const [activeTab, setActiveTab] = useState(tabList[0])
  // tab types/categories
  const speaking = [
    'All',
    'Speaking Engagements',
    'Speaking Engagements & Meetups',
    'Conferences & Speaking Engagements'
  ]
  const conference = ['All', 'Conferences', 'Conferences & Speaking Engagements', 'Conferences & Meetups']
  const meetup = ['All', 'Meetups', 'Speaking Engagements & Meetups', 'Conferences & Meetups']
  // populate tab list if card w type exist
  items.forEach((item) => {
    if (!item.type) return null
    if (speaking.includes(item.type) && !tabList.includes('Speaking Engagements')) tabList.push('Speaking Engagements')
    if (conference.includes(item.type) && !tabList.includes('Conferences')) tabList.push('Conferences')
    if (meetup.includes(item.type) && !tabList.includes('Meetups')) tabList.push('Meetups')
  })

  // set active tab on click
  const handleOnClick = (event, tab) => {
    event.preventDefault()
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  // //////////// mobile menu toggle for tabs //////////
  const [menuOpen, setMenuOpen] = useState(false)

  const toggleMenu = (event) => {
    event.preventDefault()
    if (menuOpen) {
      setMenuOpen(false)
    }
    if (!menuOpen) {
      setMenuOpen(true)
    }
  }

  const mobileNavToggle = menuOpen ? 'open' : ''

  useEffect(() => {
    setMenuOpen(false)
    setActiveTab(activeTab)
  }, [activeTab])

  // //////////// pagination logic //////////
  const paginationAmount = 9
  const [numOfPosts, setNumOfPost] = useState(paginationAmount)
  const [reachedEnd, setReachedEnd] = useState(false)

  const onLoadMore = (event) => {
    event.preventDefault()
    setNumOfPost(numOfPosts + paginationAmount)
    if (numOfPosts + paginationAmount > items.length) {
      setReachedEnd(true)
    }
  }

  /// data formatting
  const speakingArray = items.filter((card) => speaking.includes(card?.type))
  const conferenceArray = items.filter((card) => conference.includes(card?.type))
  const meetupArray = items.filter((card) => meetup.includes(card?.type))

  const dataToUse = {
    'Speaking Engagements': speakingArray,
    Conferences: conferenceArray,
    Meetups: meetupArray,
    'All Events': items
  }

  return (
    <OnVisible className="card-grid container">
      <Section>
        {/* TAB SELECT */}
        {tabList.length > 1 && (
          <div className={`card-grid-tabs ${mobileNavToggle}`}>
            {tabList.map((tab, index) => {
              const isActiveTab = tab === activeTab
              return (
                <div key={tab} className="card-grid-tab-container">
                  <button
                    type="button"
                    className={`card-grid-tab ${isActiveTab ? 'active' : ''}`}
                    onClick={(event) => handleOnClick(event, tab)}
                  >
                    {tab && <span className="card-grid-tab-title">{tab}</span>}
                  </button>
                  {index === 0 && (
                    <button type="button" onClick={toggleMenu} className="card-grid-menu-toggle">
                      <Image className="card-grid-menu-chevron" image={{ url: chevron }} />
                    </button>
                  )}
                </div>
              )
            })}
          </div>
        )}
        {/* CARD GRID */}
        <div className="card-grid-container">
          {dataToUse[activeTab].slice(0, numOfPosts).map((item) => {
            const {
              card_cta_link: ctaLink,
              card_cta_text: ctaText,
              card_excerpt: excerpt,
              card_title: title,
              image,
              tagline,
              type,
              uid
            } = item
            const titleHtml = title?.html
            const taglineHtml = tagline?.html
            const excerptHtml = excerpt?.html
            const hasLink = ctaLink?.url && ctaText?.text
            // const showCard = type === activeTab || activeTab === 'All Events' ? 'active' : ''

            return (
              <div className="card-grid-section active" key={title.text}>
                <Link to={ctaLink.url}>
                  <Image className="card-grid-image" image={image} />
                </Link>
                {taglineHtml && <div className="card-grid-tagline" dangerouslySetInnerHTML={{ __html: taglineHtml }} />}
                {titleHtml && (
                  <Link to={ctaLink.url} className="card-grid-title-link">
                    <div className="card-grid-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />
                  </Link>
                )}
                {excerptHtml && <div className="card-grid-excerpt" dangerouslySetInnerHTML={{ __html: excerptHtml }} />}
                {hasLink && (
                  <LinkWithArrow to={ctaLink.url} left>
                    {ctaText.text}
                  </LinkWithArrow>
                )}
              </div>
            )
          })}
          {/* // LOAD MORE BUTTON */}
        </div>
        {dataToUse[activeTab].length > paginationAmount && !reachedEnd && (
          <BlogButton type="button" onClick={onLoadMore} className="card-grid-button">
            LOAD MORE
          </BlogButton>
        )}
      </Section>
    </OnVisible>
  )
}

export default CardGrid
